export const toastTheme = {
  defaultProps: {
    isClosable: true,
  },
}

/** Shared panel chrome for Modal/Drawer — avoids Chakra's warm gray.800 default in dark mode. */
const overlayDialog = {
  bg: 'surface',
  color: 'text',
}

const overlayHeader = {
  borderBottomWidth: '1px',
  borderColor: 'border',
}

const overlayFooter = {
  borderTopWidth: '1px',
  borderColor: 'border',
}

const overlayCloseButton = {
  color: 'text.secondary',
  _hover: { bg: 'surface.muted' },
}

// Mobile-safe modal sizing.
//
// Two related issues:
//
// 1. Default `scrollBehavior` is "outside", which scrolls the page behind the overlay. On
//    mobile, long forms visually mix with underlying UI (e.g. Surgery filters vs modal
//    fields). Switching to "inside" makes `ModalBody` the only scroll region.
//
// 2. Chakra's built-in `sizes.full.dialog` only sets `minH: $100vh` and leaves `maxH`
//    unset, so once form content exceeds the viewport the dialog grows past it. Because the
//    dialog is unbounded, the body's `flex:1 + overflow:auto` chain never engages, the dialog
//    spills outside its container's `overflow: hidden` clip, the page scrolls, and content
//    past the visible frame renders on a transparent background.
//
//    Adding `maxH: $100vh` bounds the dialog to the visible viewport. `$100vh` resolves to
//    `var(--chakra-vh)`, which Chakra's CSS reset already cascades through the most reliable
//    viewport unit per browser (`100vh` → `-webkit-fill-available` on iOS Safari →
//    `-moz-fill-available` on Firefox → `100dvh` on modern browsers). Using bare `100vh`/
//    `100dvh` here instead would defeat that cascade and re-introduce the iOS Safari bug
//    where the dialog extends behind the URL bar.
export const modalTheme = {
  baseStyle: {
    dialog: overlayDialog,
    header: overlayHeader,
    footer: overlayFooter,
    closeButton: overlayCloseButton,
  },
  defaultProps: {
    scrollBehavior: 'inside',
  },
  sizes: {
    full: {
      dialog: {
        maxH: '$100vh',
      },
    },
  },
}

export const drawerTheme = {
  baseStyle: {
    overlay: {
      bg: 'blackAlpha.600',
    },
    dialog: overlayDialog,
    header: overlayHeader,
    footer: overlayFooter,
    closeButton: overlayCloseButton,
  },
}
